import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is C
export const ElectricCharge: BaseQuantity = {
  id: "001electriccharge",
  name: "electric_charge",
  type: "numeric",
  value: "",
  symbol: "q",
  baseUnit: "C",
  selectedUnit: "C",
  units: [
    { name: "C", fromConst: 1, toConst: 1 },
    { name: "Ah", fromConst: 3600, toConst: 1 / 3600 },
    { name: "mAh", fromConst: 3.6, toConst: 1 / 3.6 },
    {
      name: "e",
      fromConst: 1 / (6.24150975 * 10 ** 18),
      toConst: 6.24150975 * 10 ** 18,
    },
    { name: "mC", fromConst: 1 / 10 ** 3, toConst: 10 ** 3 },
    { name: "\u00B5C", fromConst: 1 / 10 ** 6, toConst: 10 ** 6 },
    { name: "nC", fromConst: 1 / 10 ** 9, toConst: 10 ** 9 },
    { name: "pC", fromConst: 1 / 10 ** 12, toConst: 10 ** 12 },
  ],
};
